import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { GraphComponent as CoreGraphComponent } from '@lib/ui';

import { UserCardService } from '../../../service/user-card.service';

@Component({
  selector: 'lib-user-card-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss'],
  imports: [
    CommonModule,
    CoreGraphComponent,
  ],
})
export class GraphComponent {
  protected readonly userCardService = inject(UserCardService);
}
